import type { AppDataAvailability } from "@lafayette/schemas";

// The words about app data on the Overview, in ONE place (CHT-2029 cards and CHT-2030 recent-visits card). The Overview says them once, in the
// notice at the top, and only when the app part of the answer is absent. A page that shows app numbers never says that app data is not available.

export function appDataWords(
  availability: Exclude<AppDataAvailability, "AVAILABLE">,
  name: string,
): string {
  switch (availability) {
    case "OPTED_OUT":
      return `${name} chose not to share app analytics. This page shows records only: requests, payments, trips and conversations.`;
    case "ANALYTICS_OFF":
      return "App activity is not recorded yet. This page shows records only.";
    case "VENDOR_UNAVAILABLE":
      return "App activity could not be read right now. This page shows records only.";
  }
}
